<template>
  <div class="menu-list-wrapper">
    <div class="menu-list-box">
      <div
        v-for="(item, index) in menuList"
        :key="index"
        :class="{ 'menu-item-style-active': selectMenuIndex === index }"
        class="menu-item-style"
        @click="clickMenuItem(index, item)"
      >
        {{ item }}
        <div class="icon-box">
          <img
            src="../../assets/images/icon/icon_table_modify.png"
            class="opinion-btn"
            alt="编辑"
            title="编辑"
            @click.stop="modifyQRCodeType(item)"
          />
          <img
            src="../../assets/images/icon/icon_table_delete.png"
            class="opinion-btn"
            alt="删除"
            title="删除"
            @click.stop="deleteQRCodeType(item)"
          />
        </div>
      </div>
    </div>

    <div
      v-if="!dataLength"
      class="empty-data"
    >
      暂无分类
    </div>

    <div class="create-btn">
      <button
        class="qrcode_handle_btn"
        @click="createType"
      >
        <i class="el-icon-plus"></i>
        创建分类
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'QRCodeTypeMenu',
  components: {},
  filters: {},
  props: {},
  data() {
    return {
      // 分类列表
      menuList: [],
      // 分类高亮index
      selectMenuIndex: 0,
    }
  },
  computed: {
    dataLength() {
      return this.menuList.length
    },
  },
  watch: {},
  created() {
    this.getQRCodeTypeData()
  },
  mounted() {},
  methods: {
    ...mapMutations('editor', ['setQRCodeType']),
		...mapGetters('editor', ['getQrcodeType']),
    /**
     * 获取二维码分类数据
     */
    async getQRCodeTypeData() {
      // 获取之前清理QRCodeType的值，保证QRCodeType的值一直有变化
      const { success, data } = await this.$http({
        url: this.$api.getQRCodeTypes,
      })
      if (success) {
        const { Types } = data
        let firstType = ''
        this.menuList = Types
        if (Types.length > 0) {
					const currentType = this.getQrcodeType()
					if (Types.includes(currentType)) {
						firstType = currentType
						this.selectMenuIndex = Types.indexOf(currentType)
					} else {
						firstType = Types[0].toString()
					}
        }
        this.setQRCodeType(firstType)
      }
    },
    /**
     * 点击二维码分类菜单
     * @param index
     * @param item
     */
    clickMenuItem(index, item) {
      this.selectMenuIndex = index
      this.setQRCodeType(item)
    },
    /**
     * 创建分类，弹出输入框
     */
    createType() {
      this.$prompt('分类名称', '添加分类', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        // 输入不为空的正则表达式
        inputPattern: /[\S]/,
        inputErrorMessage: '请输入二维码分类',
        closeOnClickModal: false,
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async content => {
          await this.commitQRCOdeType(content.value)
        })
        .catch(() => {})
    },
    /**
     * 创建分类,提交接口
     * @param value {string} 分类文本
     */
    async commitQRCOdeType(value) {
      const { success } = await this.$http({
        url: this.$api.addQRCodeType,
        method: 'post',
        data: {
          Type: value,
        },
      })
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '创建成功！' : '创建失败！',
      })
      await this.getQRCodeTypeData()
    },
    /**
     * 点击编辑按钮，弹出提示框
     * @param typeName {string} 分类名称
     */
    modifyQRCodeType(typeName) {
      this.$prompt('分类名称', '编辑分类', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        // 输入不为空的正则表达式
        inputPattern: /[\S]/,
        inputErrorMessage: '请输入二维码分类',
        inputValue: typeName,
        closeOnClickModal: false,
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async content => {
          await this.commitEdit(typeName, content.value)
        })
        .catch(() => {})
    },
    /**
     * 提交编辑接口
     * @param oldValue {string} 编辑前分类名称
     * @param newValue {string} 编辑后的分类名称
     */
    async commitEdit(oldValue, newValue) {
      const { success } = await this.$http({
        url: this.$api.updateQRCodeType,
        method: 'post',
        data: {
          OldType: oldValue,
          NewType: newValue,
        },
      })

      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '编辑成功！' : '编辑失败！',
      })
      this.selectMenuIndex = 0
      await this.getQRCodeTypeData()
    },
    /**
     * 点击删除按钮，弹出提示框
     * @param typeName {string} 分类名称
     */
    deleteQRCodeType(typeName) {
      this.$confirm('确定要删除这个分类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async () => {
          await this.commitDelete(typeName)
        })
        .catch(() => {})
    },
    /**
     * 提交删除接口
     * @param type {string} 需要删除的分类
     */
    async commitDelete(type) {
      const { success } = await this.$http({
        url: this.$api.deleteQRCodeType,
        method: 'delete',
        params: {
          type,
        },
      })
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功!' : '删除失败!',
      })
      this.selectMenuIndex = 0
      await this.getQRCodeTypeData()
    },
  },
}
</script>

<style scoped>
.menu-list-wrapper {
  height: calc(100vh - 154px);
  overflow-y: scroll;
  position: relative;
  border-right: 1px solid #dcdcdc;
  padding-top: 24px;
}
.menu-list-box {
  height: calc(100% - 80px);
  overflow: auto;
}
.menu-item-style {
  font-size: 14px;
  color: #222222;
  padding: 8px 0 8px 6px;
  margin: 10px 0;
  text-align: left;
  cursor: pointer;
}
.menu-item-style:hover {
  background: #f5f5f5;
}
.menu-item-style-active {
  color: #1598d9;
  font-weight: 700;
  background-color: #f0f6ff !important;
}
.create-btn {
  position: absolute;
  bottom: 40px;
  left: 25%;
}
.create-btn i {
  font-size: 14px;
}
.empty-data {
  text-align: center;
  font-size: 13px;
  color: #cccccc;
  margin-top: 50px;
}
.opinion-btn {
  width: 24px;
  height: 24px;
}
.icon-box {
  float: right;
  margin-right: 10px;
  margin-top: -5px;
}
.btn-box {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  width: 72px;
  text-align: center;
  margin-right: 14px;
  background: #1598d9;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.btn-box i {
  font-size: 14px;
  color: #ffffff;
  margin-right: 4px;
  font-weight: 700;
}
.btn-box:active {
  background: #1372a1;
}
</style>
